import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _typeof from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { newServerRoleProductPenetrationRateCurrency, newServerRoleProductPenetrationRate } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import * as XLSX from 'xlsx';
export default {
  name: "newUserPaid",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [{
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user",
        penetration: 3
      },
      tableList: [],
      serverList: [],
      levelList: [],
      exportdataDealoading: false,
      // 存储后端返回的date_order_product_id_arr
      dateOrderProductIdArr: {},
      // 存储需要展示的日期+次数组合（过滤掉无数据的）
      validDateTimeCombination: []
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];
      this.dateOrderProductIdArr = {};
      this.validDateTimeCombination = []; // 重置有效组合

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (!this.paramsData.dimension_kind) {
        this.$message.error(this.$t('pleaseSelectNewDeviceOrAccount'));
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels,
        penetration: this.paramsData.penetration,
        ad_channel: this.searchData.ad_channel,
        ad_placement: this.searchData.ad_placement
      }; //判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? newServerRoleProductPenetrationRateCurrency : newServerRoleProductPenetrationRate;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          var _ret = function () {
            if (!res.data) {
              return {
                v: void 0
              };
            }

            var data = res.data;
            var tier_config = res.tier_config;
            var product_id_arr = res.product_id_arr;
            _this2.dateOrderProductIdArr = res.date_order_product_id_arr || {}; // ========== 核心逻辑1：过滤user_count>0的层级 ==========

            var levelUserCountMap = {};

            for (var date in data) {
              for (var level in data[date]) {
                var userCount = data[date][level].user_count || 0;

                if (!levelUserCountMap[level]) {
                  levelUserCountMap[level] = 0;
                }

                if (userCount > 0) {
                  levelUserCountMap[level] = userCount;
                }
              }
            } // 只保留user_count>0的层级


            _this2.tableData = Object.keys(tier_config).filter(function (level) {
              return levelUserCountMap[level] > 0;
            }).map(function (level) {
              return {
                level: level,
                recharge_range: tier_config[level].range,
                label: tier_config[level].label
              };
            }); // ========== 核心逻辑2：筛选有数据的日期+次数组合 ==========

            _this2.filterValidDateTimeCombination(data); // ========== 处理表格表头 ==========


            _this2.tableList = [{
              label: "",
              prop: "recharge_range",
              list: [{
                label: _this2.$t('payAmount'),
                prop: "recharge_range",
                level: "all"
              }]
            }];
            var isFirstDate = true; // 遍历所有日期

            var _loop = function _loop(_date) {
              var dateItem = {
                label: _date,
                prop: _date,
                list: []
              }; // 只给第一个日期添加付费人数列

              if (isFirstDate) {
                dateItem.list.push({
                  label: _this2.$t('payPeopleCount'),
                  prop: "".concat(_date, "-user_count"),
                  level: "all"
                });
                isFirstDate = false;
              } // 获取当前日期下的有效次数（过滤掉无数据的次数）


              var validTimes = _this2.validDateTimeCombination.filter(function (item) {
                return item.date === _date;
              }).map(function (item) {
                return item.time;
              }); // 去重并排序


              var uniqueValidTimes = _toConsumableArray(new Set(validTimes)).sort(function (a, b) {
                return a - b;
              }); // 只处理有数据的次数


              uniqueValidTimes.forEach(function (time) {
                var _this2$dateOrderProdu2;

                var timesItem = {
                  label: _this2.$t('timesLabel', {
                    time: time
                  }),
                  prop: time,
                  level: "all",
                  list: []
                }; // 获取当前日期+次数对应的商品ID列表

                var showProductIds = ((_this2$dateOrderProdu2 = _this2.dateOrderProductIdArr[_date]) === null || _this2$dateOrderProdu2 === void 0 ? void 0 : _this2$dateOrderProdu2[time]) || []; // 添加商品总数列（只有有商品数据时才加）

                if (showProductIds.length > 0) {
                  timesItem.list.push({
                    label: _this2.$t('productTotalCount'),
                    prop: "".concat(_date, "-").concat(time, "-total")
                  });
                } // 添加商品列


                showProductIds.forEach(function (productId) {
                  if (product_id_arr[productId]) {
                    timesItem.list.push({
                      label: "".concat(productId, ",").concat(product_id_arr[productId]),
                      prop: "".concat(_date, "-").concat(time, "-").concat(productId)
                    });
                  }
                }); // 只有有子列时才添加

                if (timesItem.list.length > 0) {
                  dateItem.list.push(timesItem);
                }
              }); // 只有有子列时才添加日期项

              if (dateItem.list.length > 0) {
                _this2.tableList.push(dateItem);
              }
            };

            for (var _date in data) {
              _loop(_date);
            } // ========== 填充表格数据 ==========


            _this2.tableData.forEach(function (row) {
              var level = row.level;

              _this2.tableList.forEach(function (dateColumn) {
                var date = dateColumn.prop;
                if (date === "recharge_range") return; // 处理付费人数

                dateColumn.list.forEach(function (subColumn) {
                  if (subColumn.label === _this2.$t('payPeopleCount')) {
                    var _data$date, _data$date$level;

                    row["".concat(date, "-user_count")] = ((_data$date = data[date]) === null || _data$date === void 0 ? void 0 : (_data$date$level = _data$date[level]) === null || _data$date$level === void 0 ? void 0 : _data$date$level.user_count) || 0;
                  }
                }); // 处理购买次数数据

                var validTimes = _this2.validDateTimeCombination.filter(function (item) {
                  return item.date === date;
                }).map(function (item) {
                  return item.time;
                });

                validTimes.forEach(function (time) {
                  var _this2$dateOrderProdu;

                  var showProductIds = ((_this2$dateOrderProdu = _this2.dateOrderProductIdArr[date]) === null || _this2$dateOrderProdu === void 0 ? void 0 : _this2$dateOrderProdu[time]) || []; // 填充商品总数

                  if (showProductIds.length > 0) {
                    var _data$date2, _data$date2$level, _data$date2$level$pur, _data$date2$level$pur2;

                    var totalProp = "".concat(date, "-").concat(time, "-total");
                    row[totalProp] = ((_data$date2 = data[date]) === null || _data$date2 === void 0 ? void 0 : (_data$date2$level = _data$date2[level]) === null || _data$date2$level === void 0 ? void 0 : (_data$date2$level$pur = _data$date2$level.purchase_stats) === null || _data$date2$level$pur === void 0 ? void 0 : (_data$date2$level$pur2 = _data$date2$level$pur[time]) === null || _data$date2$level$pur2 === void 0 ? void 0 : _data$date2$level$pur2.total) || 0;
                  } // 填充商品数据


                  showProductIds.forEach(function (productId) {
                    var _data$date3, _data$date3$level, _data$date3$level$pur, _data$date3$level$pur2, _data$date3$level$pur3;

                    var productProp = "".concat(date, "-").concat(time, "-").concat(productId);
                    var productData = (_data$date3 = data[date]) === null || _data$date3 === void 0 ? void 0 : (_data$date3$level = _data$date3[level]) === null || _data$date3$level === void 0 ? void 0 : (_data$date3$level$pur = _data$date3$level.purchase_stats) === null || _data$date3$level$pur === void 0 ? void 0 : (_data$date3$level$pur2 = _data$date3$level$pur[time]) === null || _data$date3$level$pur2 === void 0 ? void 0 : (_data$date3$level$pur3 = _data$date3$level$pur2.products) === null || _data$date3$level$pur3 === void 0 ? void 0 : _data$date3$level$pur3[productId];
                    row[productProp] = productData || '0';
                  });
                });
              });
            });
          }();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },

    /**
     * 筛选有数据的日期+次数组合
     * 规则：date_order_product_id_arr中该组合的商品ID数组非空，且对应total>0
     */
    filterValidDateTimeCombination: function filterValidDateTimeCombination(data) {
      this.validDateTimeCombination = [];

      for (var date in this.dateOrderProductIdArr) {
        var timeObj = this.dateOrderProductIdArr[date];

        for (var time in timeObj) {
          var productIds = timeObj[time] || []; // 条件1：商品ID数组非空
          // 条件2：该日期+次数下至少有一个层级的total>0

          var hasValidTotal = false;

          for (var level in data[date]) {
            var _data$date$level2, _data$date$level2$pur, _data$date$level2$pur2;

            var total = ((_data$date$level2 = data[date][level]) === null || _data$date$level2 === void 0 ? void 0 : (_data$date$level2$pur = _data$date$level2.purchase_stats) === null || _data$date$level2$pur === void 0 ? void 0 : (_data$date$level2$pur2 = _data$date$level2$pur[time]) === null || _data$date$level2$pur2 === void 0 ? void 0 : _data$date$level2$pur2.total) || 0;

            if (total > 0) {
              hasValidTotal = true;
              break;
            }
          } // 只有满足条件才加入有效组合


          if (productIds.length > 0 && hasValidTotal) {
            this.validDateTimeCombination.push({
              date: date,
              time: time
            });
          }
        }
      }
    },
    exportdata: function exportdata() {
      var _this3 = this;

      this.exportdataDealoading = true;

      try {
        // 1. 构建工作表数据
        var wsData = []; // 2. 构建四级表头

        var headerRow1 = [this.$t('payAmount')];
        var headerRow2 = [this.$t('amountRange')];
        var headerRow3 = [''];
        var headerRow4 = [''];
        var isFirstDateHeader = true; // 处理日期和对应的子列

        this.tableList.forEach(function (dateColumn) {
          if (dateColumn.prop === 'recharge_range') return;
          var dateLabel = dateColumn.label;
          var dateColumnCount = 0;
          dateColumn.list.forEach(function (subColumn) {
            if (subColumn.label === _this3.$t('payPeopleCount')) {
              dateColumnCount += 1;
            } else if (subColumn.list) {
              dateColumnCount += subColumn.list.length;
            }
          }); // 第一行：日期（跨列）

          headerRow1.push(dateLabel);

          for (var i = 1; i < dateColumnCount; i++) {
            headerRow1.push('');
          } // 处理子列


          dateColumn.list.forEach(function (subColumn) {
            if (subColumn.label === _this3.$t('payPeopleCount') && isFirstDateHeader) {
              headerRow2.push(_this3.$t('payPeopleCount'));
              headerRow3.push("");
              headerRow4.push("");
            } else if (subColumn.list) {
              var timesLabel = subColumn.label;
              var columnCount = subColumn.list.length; // 第二行：次数（跨列）

              headerRow2.push(timesLabel);

              for (var _i = 1; _i < columnCount; _i++) {
                headerRow2.push('');
              } // 第三、四行：商品列


              subColumn.list.forEach(function (productColumn) {
                if (productColumn.label === _this3.$t('productTotalCount')) {
                  headerRow3.push(productColumn.label);
                  headerRow4.push('');
                } else {
                  var labelParts = productColumn.label.split(',');
                  headerRow3.push(labelParts[0] || '');
                  headerRow4.push(labelParts[1] || '');
                }
              });
            }
          });

          if (isFirstDateHeader) {
            isFirstDateHeader = false;
          }
        }); // 添加表头行

        wsData.push(headerRow1);
        wsData.push(headerRow2);
        wsData.push(headerRow3);
        wsData.push(headerRow4); // 3. 构建数据行

        this.tableData.forEach(function (row) {
          var rowData = [row.recharge_range || ''];
          var isFirstDateData = true;

          _this3.tableList.forEach(function (dateColumn) {
            if (dateColumn.prop === 'recharge_range') return;
            var date = dateColumn.prop;
            dateColumn.list.forEach(function (subColumn) {
              if (subColumn.label === _this3.$t('payPeopleCount') && isFirstDateData) {
                rowData.push(row["".concat(date, "-user_count")] || 0);
              } else if (subColumn.list) {
                var time = subColumn.prop;
                subColumn.list.forEach(function (productColumn) {
                  var prop;

                  if (productColumn.label === _this3.$t('productTotalCount')) {
                    prop = "".concat(date, "-").concat(time, "-total");
                  } else {
                    prop = "".concat(date, "-").concat(time, "-").concat(productColumn.label.split(',')[0]);
                  }

                  rowData.push(row[prop] || 0);
                });
              }
            });

            if (isFirstDateData) {
              isFirstDateData = false;
            }
          });

          wsData.push(rowData);
        }); // 4. 创建工作表

        var ws = XLSX.utils.aoa_to_sheet(wsData); // 5. 设置合并单元格

        var merges = [];
        merges.push({
          s: {
            r: 0,
            c: 0
          },
          e: {
            r: 3,
            c: 0
          }
        }); // 合并付费金额

        var colIndex = 1;
        var isFirstDateMerge = true;
        this.tableList.forEach(function (dateColumn) {
          if (dateColumn.prop === 'recharge_range') return;
          var dateColumnCount = 0;
          dateColumn.list.forEach(function (subColumn) {
            if (subColumn.label === _this3.$t('payPeopleCount') && isFirstDateMerge) {
              dateColumnCount += 1;
            } else if (subColumn.list) {
              dateColumnCount += subColumn.list.length;
            }
          }); // 合并日期单元格

          if (dateColumnCount > 1) {
            merges.push({
              s: {
                r: 0,
                c: colIndex
              },
              e: {
                r: 0,
                c: colIndex + dateColumnCount - 1
              }
            });
          } // 处理子列合并


          dateColumn.list.forEach(function (subColumn) {
            if (subColumn.label === _this3.$t('payPeopleCount') && isFirstDateMerge) {
              merges.push({
                s: {
                  r: 1,
                  c: colIndex
                },
                e: {
                  r: 3,
                  c: colIndex
                }
              });
              colIndex++;
            } else if (subColumn.list) {
              var columnCount = subColumn.list.length; // 合并次数单元格

              if (columnCount > 1) {
                merges.push({
                  s: {
                    r: 1,
                    c: colIndex
                  },
                  e: {
                    r: 1,
                    c: colIndex + columnCount - 1
                  }
                });
              } // 处理商品列合并


              subColumn.list.forEach(function (productColumn, index) {
                var currentCol = colIndex + index;

                if (productColumn.label === _this3.$t('productTotalCount')) {
                  merges.push({
                    s: {
                      r: 2,
                      c: currentCol
                    },
                    e: {
                      r: 3,
                      c: currentCol
                    }
                  });
                }
              });
              colIndex += columnCount;
            }
          });

          if (isFirstDateMerge) {
            isFirstDateMerge = false;
          }
        });
        ws['!merges'] = merges; // 6. 设置列宽

        var colWidths = [{
          width: 15
        }];

        var _loop2 = function _loop2(i) {
          var _headerRow2$i, _headerRow3$i, _headerRow4$i;

          var maxLength = Math.max.apply(Math, [((_headerRow2$i = headerRow2[i]) === null || _headerRow2$i === void 0 ? void 0 : _headerRow2$i.toString().length) || 0, ((_headerRow3$i = headerRow3[i]) === null || _headerRow3$i === void 0 ? void 0 : _headerRow3$i.toString().length) || 0, ((_headerRow4$i = headerRow4[i]) === null || _headerRow4$i === void 0 ? void 0 : _headerRow4$i.toString().length) || 0].concat(_toConsumableArray(wsData.slice(4).map(function (row) {
            return row[i] ? row[i].toString().length : 0;
          }))));
          colWidths.push({
            width: Math.min(Math.max(maxLength + 2, 8), 20)
          });
        };

        for (var i = 1; i < headerRow4.length; i++) {
          _loop2(i);
        }

        ws['!cols'] = colWidths; // 7. 设置单元格样式

        var range = XLSX.utils.decode_range(ws['!ref']); // 表头样式

        for (var R = 0; R < 4; R++) {
          for (var C = range.s.c; C <= range.e.c; C++) {
            var cellAddress = XLSX.utils.encode_cell({
              r: R,
              c: C
            });
            if (!ws[cellAddress]) ws[cellAddress] = {
              t: 's',
              v: ''
            };
            ws[cellAddress].s = {
              font: {
                bold: true,
                sz: 10
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true
              },
              fill: {
                fgColor: {
                  rgb: "E6E6FA"
                }
              }
            };
          }
        } // 数据行样式


        for (var _R = 4; _R <= range.e.r; _R++) {
          for (var _C = range.s.c; _C <= range.e.c; _C++) {
            var _cellAddress = XLSX.utils.encode_cell({
              r: _R,
              c: _C
            });

            if (ws[_cellAddress] && !ws[_cellAddress].s) {
              ws[_cellAddress].s = {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center'
                }
              };
            }
          }
        } // 8. 导出文件


        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, this.$t('paymentPenetrationRateSheet'));
        var fileName = "".concat(this.$t('newUserPaymentPenetrationRate'), ".xlsx");
        XLSX.writeFile(wb, fileName);
        this.$message.success(this.$t('exportSuccess'));
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error(this.$t('exportFailedRetry'));
      } finally {
        this.exportdataDealoading = false;
      }
    }
  }
};